/**
 * Generated by orval v6.18.1 🍺
 * Do not edit manually.
 * My Title
 * OpenAPI spec version: 1.0.0
 */

export type CarBrandSpec = (typeof CarBrandSpec)[keyof typeof CarBrandSpec];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CarBrandSpec = {
  None: 1,
  Authorized: 2,
  Warranty: 3,
} as const;
